'use client';

import { SpotMarketConfig } from '@drift-labs/sdk';
import MarketIcon from 'src/components/Utils/MarketIcon';
import { UIMarket } from '@drift/common';
import Input from 'src/components/primitives/Input/Input';

type FixedAssetInputProps = {
	selectedMarket: SpotMarketConfig;
	onChangeValue: (val?: string) => void;
	value?: string;
};

const FixedAssetInput = ({
	selectedMarket,
	onChangeValue,
	value,
}: FixedAssetInputProps) => {
	const selectedMarketUIConfig = UIMarket.createSpotMarket(
		selectedMarket.marketIndex
	);

	return (
		<Input
			variant="default"
			labelVariant="none"
			type="number"
			size="md"
			value={value}
			onChange={onChangeValue}
			prefixClassName="gap-x-sm items-center shrink-0"
			prefix={
				<>
					<MarketIcon
						marketSymbol={selectedMarketUIConfig.uiSymbols.baseAssetSymbol}
						className="size-4"
					/>
					{selectedMarketUIConfig.uiSymbols.baseAssetSymbol}
				</>
			}
		/>
	);
};

export default FixedAssetInput;
